

















import { Vue, Prop, Watch, Component } from "vue-property-decorator";

import Notifications from "@env/shared/notifications/Notifications.vue";
import YesNo from "@env/shared/modals/YesNo.vue";
import Menu from "./controles/Menu.vue";
import Footer from "./controles/Footer.vue";

@Component( {
    name: "Template",
    props: {},
    components: {
        Footer,
        Menu,
        Notifications,
        YesNo,
    }
} )
export default class Template extends Vue {

    constructor() {
        super();
    }

    public async mounted() {

        this.$EventBus.$on( 'toolbar-titulo', (x:string) => { this.cambiarTitulo( x ); } );
        this.$EventBus.$on( 'toolbar-mostrar', () => { this.Barra = true; } );
        this.$EventBus.$on( 'toolbar-ocultar', () => { this.Barra = false; } );

        this.Listo = true;
    }

    cambiarTitulo( titulo: string ) {
        this.Titulo = '';
        this.$nextTick( () => {
            this.Titulo = titulo;
        } )
    }

    public async destroy() {
        this.$socket.client.disconnect();
        this.$socket.client.close();
    }

    public Titulo: string = 'Inicio';
    public drawer: boolean = false;
    public Listo: boolean = false;
    public Barra: boolean = false;

    public get muestraMenu(): boolean {
        return !this.$vuetify.breakpoint.xsOnly && !this.$router.currentRoute.path.includes( 'chat' );
    }

    public atras() {
        this.Titulo = '';
        this.$router.back();
    }
}
